import React from 'react';
import { Building2, Phone, Mail, MapPin, Facebook, Instagram, ExternalLink, Laptop } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand & Social */}
          <div className="footer-column brand-column">
            <div className="footer-logo">
              <Building2 className="footer-logo-icon" />
              <span className="footer-brand-name">Hasan Korkmaz</span>
            </div>
            <p className="footer-description">
              Gayrimenkul sektöründe profesyonel çözümler. RE/MAX West çatısı altında 
              hayallerinizdeki mülke kavuşmanız için yanınızdayım.
            </p>
            <div className="footer-socials">
              <a href="https://www.facebook.com/hasan.korkmaz.3597789?locale=tr_TR" target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/hasan_korkmaz_remax?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="Instagram">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Contact Information */}
          <div className="footer-column">
            <h3 className="footer-heading">İletişim</h3>
            <div className="footer-contact-list">
              <div className="footer-contact-item">
                <Phone size={18} className="footer-contact-icon" />
                <a href="tel:+905052149197" className="footer-contact-link">+90 505 214 91 97</a>
              </div>
              <div className="footer-contact-item">
                <Mail size={18} className="footer-contact-icon" />
                <span>hasankorkmaz@remax.com.tr</span>
              </div>
              <div className="footer-contact-item">
                <MapPin size={18} className="footer-contact-icon" />
                <a 
                  href="https://maps.app.goo.gl/kKS1Vk3GJXWYmhWx7" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="footer-contact-link"
                >
                  RE/MAX West Ofisi<br />Karşıyaka/İzmir
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h3 className="footer-heading">Hızlı Bağlantılar</h3>
            <ul className="footer-links">
              <li>
                <a href="https://remaxwestgayrimenkul.sahibinden.com/emlak?sorting=storeShowcase&userId=a1vTMw-NBI5dzdzBpzSz07w" target="_blank" rel="noopener noreferrer" className="footer-link">
                  Sahibinden Mağaza <ExternalLink size={14} />
                </a>
              </li>
              <li>
                <a href="https://www.remax.com.tr/danisman/40174/hasan-korkmaz" target="_blank" rel="noopener noreferrer" className="footer-link">
                  RE/MAX Profil <ExternalLink size={14} />
                </a>
              </li>
              <li><button className="footer-link-btn">Hakkımda</button></li>
              <li><button className="footer-link-btn">Gizlilik Politikası</button></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Hasan Korkmaz RE/MAX West. Tüm hakları saklıdır.</p>
          <p className="developer-credit">
            <a href="https://egehankorkmaz.vercel.app/" target="_blank" rel="noopener noreferrer">
              <Laptop size={14} style={{ marginRight: '6px' }} />
              Egehan Korkmaz tarafından tasarlanmıştır
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
